module.exports = __webpack_public_path__ + "img/plan-b-other.a52319d8.png";